import { down } from 'styled-breakpoints'
import styled, { keyframes, css } from 'styled-components'
import { mobileStyles, desktopStyles } from 'utils/styleHelpers'

const slideRightAndBack = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-100px);
  }
  100% {
    transform: translateX(0);
  }
`

const SearchFormContainer = styled.div<{ imgUrl?: string; showBanner?: boolean; isMobile?: boolean; isTablet?: boolean; $minHeight?: number }>`
  display: flex;
  width: 100%;
  min-height: 510px;
  flex-direction: column;
  position: relative;
  margin-top: -56px;
  padding-bottom: 40px;

  ${({ $minHeight, isMobile, isTablet }) =>
    !isMobile &&
    !isTablet &&
    $minHeight
      ? css`
          min-height: ${$minHeight}px;
        `
      : undefined}

  [data-testid='car-rental-driver-age-options'] {
    height: 200px;
    top: 25px;
  }

  /* endesign CarRentalMobileForm padding-inline: 12px — homepage kenar boşluğunu sıfırlar */
  [class*='carRentalMobileForm'] {
    padding-inline: 0;
  }

  [dir='rtl'] & [data-testid='flight-origin-suffix'] {
    left: 5px !important;
  }

  ${down('sm')} {
    ${(p) =>
      p.isReady &&
      css`
        div[role='tablist'] > div > button {
          animation: ${slideRightAndBack} 1.5s ease-in-out;
          animation-iteration-count: 1;
        }
      `}
  }

  /* Desktop görünümü - SSR kontrolü ile tablet'ler mobil görecek */
  ${desktopStyles`
    background-image: linear-gradient(rgba(2, 17, 65, 0.7), rgba(2, 17, 65, 0.25), rgba(2, 17, 65, 0.2));
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  `}

  /* Mobil/Tablet görünümü - SSR kontrolü ile tablet'ler de dahil */
  ${mobileStyles`
    min-height: 0px;
    background-color: #2dc44d;
    padding-top: 60px;
    padding-bottom: 0px;
  `}

  ${down('lg')} {
    padding-top: ${({ showBanner, isTablet }) => (showBanner ? '200px' : isTablet ? '124px' : '70px')};
  }
`

const Content = styled.div<{ isMobile?: boolean; isTablet?: boolean; showBanner?: boolean }>`
  display: ${(props) => !props.isMobile && !props.isTablet && 'block'};
  margin: ${(props) => !props.isMobile && !props.isTablet && '0 auto'};
  width: ${(props) => !props.isMobile && !props.isTablet && '1120px'};
  max-width: ${(props) => !props.isMobile && !props.isTablet && '100%'};
  margin-bottom: ${(props) => !props.isMobile && !props.isTablet && '0px'};
  overflow: visible;

  ${mobileStyles`
    margin-top: 50px;
    max-width: 100%;
  `}

  /* Tablet için mobil padding'leri uygula */
  ${(props) =>
    props.isTablet &&
    css`
      margin: 0 !important;
      width: auto !important;
      max-width: 100% !important;
    `}

  ${down('lg')} {
    ${({ showBanner }) =>
      showBanner &&
      css`
        margin-top: 24px !important;
      `}
  }
`
export const HeadTitle = styled.h1`
  color: #fff;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 27px;
  text-align: center;
  margin: 12px 0;
`

const TravelDocument = styled.div`
  /* margin-top: 24px; */
  color: #fff;
  font-size: 12px;
  /* margin-bottom: 10px; */
  bottom: 10px;
  position: absolute;
`

export const IntroTitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 120px 0 40px 0;
  overflow: visible;

  @media (max-width: 768px) {
    margin: 56px 0 0 0;
  }
`

export const IntroTitleInner = styled.div`
  position: relative;
  display: inline-block;
  overflow: visible;
`

const IntroTitle = styled.h1`
  color: #fff;
  font-size: 36px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 33px;
  margin: 0;
  text-align: center;
  font-style: normal;
  line-height: normal;

  html[dir='rtl'] & {
    line-height: 1.4;
  }

  @media (max-width: 768px) {
    font-size: 18px;
    color: #53605e;
    text-align: center;

    html[dir='rtl'] & {
      line-height: 1.5;
    }
  }
`

const IntroSubTitle = styled.h2`
  color: #fff;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: -24px;
`
const SearchFormMobileContainer = styled.div<{ isTablet?: boolean; $variant?: string }>`
  position: relative;

  [data-testid$='-tab-left-wrapper'] {
    margin-top: -20px;
    padding-top: 20px;
  }

  /* Badge için sadece tablist seviyesinde overflow visible */
  div[role='tablist'] {
    overflow: visible !important;
  }

  /* Button'larda overflow visible - badge için gerekli */
  div[role='tablist'] > div > button {
    position: relative;
    overflow: visible !important;

    a {
      position: unset;
    }
    a:after {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      border-radius: 18px;
    }
  }

  ${({ $variant }) =>
    $variant === 'B' &&
    css`
      background-color: transparent !important;
      padding: 0 !important;
      margin-top: 8px;

      [data-testid='endesign-search-form-tab-list'] {
        width: 95%;
        margin: auto;
        margin-bottom: 14px;
      }
    `}
`

export { SearchFormContainer, IntroTitle, Content, TravelDocument, IntroSubTitle, SearchFormMobileContainer }
